import script from "./AdvancedHotspots.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdvancedHotspots.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__